import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'

import FormatUtils from '@front/squirtle/utils/format'
import { TextCell } from '@abra/elements/table/cells/basics/'
import { DriverLink, VehicleLink, OrderLink, StaffLink } from '@abra/elements'
import AssociatedInfoComponent from '@abra/elements/event/Data/'

const Row = ({ row }) => {
  return <>
    <TableCell>
      <TextCell value={FormatUtils.formatDateBackToFront(row?.createdAt, 'DD/MM/YY HH[h]mm')} variant='small' />
    </TableCell>
    <TableCell>
      <StaffLink record_id={row?.operator} hidden={!row?.operator} />
    </TableCell>
    <TableCell>
      <OrderLink record_id={row?.order} hidden={!row?.order} />
    </TableCell>
    <TableCell>
      <DriverLink record_id={row?.driver} hidden={!row?.driver} />
    </TableCell>
    <TableCell>
      <VehicleLink record_id={row?.vehicle} hidden={!row?.vehicle} />
    </TableCell>
    <TableCell>
      <TextCell value={I18n.t(`event.${row?.name}`)} variant='small' />
    </TableCell>
    <TableCell sx={{ maxWidth: 300 }}>
      <AssociatedInfoComponent data={row?.data || []} action={row?.action} />
    </TableCell>
  </>
}

export default React.memo(Row)
